/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_List_Actions_LabelInputs */



/**
* | output |
* | --- |
* | "Marker list actions" |
*
* @param {Markers_List_Actions_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_list_actions_label = /** @type {((inputs?: Markers_List_Actions_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_List_Actions_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actions de liste de marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktionen in der Markerliste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Azioni dell'elenco dei marcatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Действия списка маркеров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Acciones de la lista de marcadores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标记列表操作")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーリストのアクション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर सूची क्रियाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ações da lista de marcadores")
	return /** @type {LocalizedString} */ ("Marker list actions")
});